export const addZeroCentIfNecessary = (value: string, anyError: string): string => {
  if (anyError === '' && !value.includes('.')) {
    return value + '.00';
  } else if (anyError === '' && value.charAt(value.length - 1) === '.') {
    return value + '00';
  } else if (anyError === '' && value.charAt(value.length - 2) === '.') {
    return value + '0';
  } else {
    return value;
  }
};



// WEBPACK FOOTER //
// ./src/util/AmountUtil.tsx